const assetsRoute = (name, path, ext) => {
    return `${environment.DOMAIN}/wp-content/themes/observatorio-omt-web/assets/${path}/${name}${ext}`;
}

export default assetsRoute